// extracted by mini-css-extract-plugin
export var select = "_r9-0";